import { StyleSheet } from 'react-native-unistyles';

import { theme } from '@squire/ui';

export const styles = StyleSheet.create((colors, rt) => ({
  bottomSheet: {
    paddingTop: theme.spacing[4],
    backgroundColor: colors.backgroundL0,
  },
  background: {
    backgroundColor: colors.backgroundL0,
    paddingHorizontal: theme.spacing[4],
    paddingBottom: rt.insets.bottom + theme.spacing[4],
    gap: theme.spacing[7],
  },
  loadingContent: {
    width: '100%',
    flexDirection: 'row',
    justifyContent: 'center',
    alignItems: 'center',
  },
}));
